import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { KpiCard, ToggleBarChart } from '../../../common/analytics';
import { MONETIZATION_KPI_ICONS, USER_ADOPTION_FREQUENCIES } from '../../dashboard.constants';
import CardSkeleton from '../../../common/cardSkeleton/CardSkeleton';
import styles from './styles/monetization-kpis-section.module.scss';

function MonetizationKpisSection({ kpis = [], feeIncome, directDeposit, loading = false }) {
    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Usage KPIs</Text>

            {loading ? (
                <>
                    <div className={styles.kpiRow}>
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                    </div>
                    <div className={styles.chartsRow}>
                        <CardSkeleton minHeight={420} rows={6} />
                        <CardSkeleton minHeight={420} rows={6} />
                    </div>
                </>
            ) : (
                <>
            <div className={styles.kpiRow}>
                {kpis.map((kpi) => (
                    <KpiCard
                        key={kpi.key}
                        label={kpi.label}
                        value={kpi.value}
                        variant={kpi.variant}
                        conversionRate={kpi.conversionRate}
                        icon={MONETIZATION_KPI_ICONS[kpi.key]}
                        isCurrency={kpi.isCurrency}
                    />
                ))}
            </div>

            <div className={styles.chartsRow}>
                <ToggleBarChart
                    title={feeIncome.title}
                    subtitle={feeIncome.subtitle}
                    toggles={USER_ADOPTION_FREQUENCIES}
                    defaultToggle="monthly"
                    series={feeIncome.series}
                    data={feeIncome.data}
                    isCurrency
                />
                <ToggleBarChart
                    title={directDeposit.title}
                    subtitle={directDeposit.subtitle}
                    toggles={USER_ADOPTION_FREQUENCIES}
                    defaultToggle="monthly"
                    series={directDeposit.series}
                    data={directDeposit.data}
                />
            </div>
                </>
            )}
        </section>
    );
}

export default MonetizationKpisSection;
